import * as React from "react";
import { Provider, Flex, teamsTheme } from "@fluentui/react-northstar";
import { useTeams } from "msteams-react-base-component";
import { app } from "@microsoft/teams-js";
import RoomScheduleFullCalendar from "./RoomScheduleFullCalendar";
import { useResponsive } from "./hooks/useResponsive";
import RoomScheduleMobile from "./RoomScheduleMobile";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const SetaTab = () => {
  const { device } = useResponsive();
  const [{ inTeams, theme }] = useTeams();

  React.useEffect(() => {
    if (inTeams === true) {
      app.notifySuccess();
    }
  }, [inTeams]);

  return (
    <div style={{ width: "100vw", height: "100vh", overflow: "hidden" }}>
      <Provider theme={teamsTheme} styles={{ width: "100%", height: "100%" }}>
        <Flex fill column styles={{ width: "100%", height: "100%", padding: 0 }}>
          <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar />

          {device === "mobile" ? <RoomScheduleMobile /> : <RoomScheduleFullCalendar />}

        </Flex>
      </Provider>
    </div>
  );
};
